import { ArrowLeftIcon } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import colors from 'tailwindcss/colors';

import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  backPath?: string;
  asChildPage?: boolean;
  onBack?: () => void;
  actions?: React.ReactNode[];
}

export function PageHeader({
  title,
  actions,
  onBack,
  backPath,
  asChildPage = false,
}: PageHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
    onBack?.();
  };

  return (
    <header
      className="flex justify-between items-center pb-[24px]"
      data-testid="page-header"
    >
      <div
        className={cn(
          'flex gap-2 items-center',
          asChildPage && 'cursor-pointer hover:opacity-80'
        )}
        data-testid="page-header-title"
        onClick={handleBack}
      >
        {asChildPage && (
          <ArrowLeftIcon className="w-6 h-6" color={colors.gray[100]} />
        )}
        <h2 className="text-3xl font-semibold">{title}</h2>
      </div>
      {actions}
    </header>
  );
}
